<div class="card-slideshow-wrapper flex flex-col">
  <!-- Header -->
  <div class="slider-header flex justify-between">
    <div class="title title-sm ml-1">{{ title }}</div>
    <div class="slider-controls flex">
      <span
        class="previous icon2-x16-chevron-l"
        title="{{ 'ui2-card-slideshow.controls.previous' | translate }}"
        (click)="scrollLeft()"
        [class.active]="isPreviousButtonActive"
      ></span>

      <span
        class="next icon2-x16-chevron-l"
        title="{{ 'ui2-card-slideshow.controls.next' | translate }}"
        (click)="scrollRight()"
        [class.active]="isNextButtonActive"
      ></span>
    </div>
  </div>

  <!-- card List -->
  <div #cardsList class="cards flex" #cardScrollWrapper>
    <ng-container *ngTemplateOutlet="cardListTemplate"></ng-container>
  </div>
</div>
